import React from "react";
import {
  ResponsiveContainer,
  LineChart, Line,
  BarChart, Bar,
  PieChart, Pie, Cell,
  XAxis, YAxis, Tooltip, CartesianGrid,
} from "recharts";

const COLORS = ["#2d1c87", "#6a4bd6", "#52c4c1", "#e6a100", "#d93838", "#2e9e5b", "#4a34b8", "#9a8fd0"];

function ChartCard({ title, children, empty }) {
  return (
    <div className="lf-chart-card">
      <h4>{title}</h4>
      {empty ? (
        <div className="lf-empty" style={{ padding: "30px 10px" }}>No data yet</div>
      ) : (
        <ResponsiveContainer width="100%" height={240}>
          {children}
        </ResponsiveContainer>
      )}
    </div>
  );
}

function LeadFinderAnalytics({ stats }) {
  if (!stats) return null;

  const perDay = (stats.leadsPerDay || []).map((d) => ({
    day: d.day ? String(d.day).slice(5) : "",
    count: d.count,
  }));

  const availability = [
    { name: "With Email", value: stats.emailsFound || 0 },
    { name: "With Phone", value: stats.phonesFound || 0 },
    { name: "With Website", value: stats.websitesFound || 0 },
  ];

  return (
    <div className="lf-analytics-grid">
      <ChartCard title="Leads per Day" empty={perDay.length === 0}>
        <LineChart data={perDay}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis dataKey="day" tick={{ fontSize: 12 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Line type="monotone" dataKey="count" stroke="#2d1c87" strokeWidth={2.5} dot={{ r: 3 }} />
        </LineChart>
      </ChartCard>

      <ChartCard title="Top Categories" empty={(stats.topCategories || []).length === 0}>
        <BarChart data={stats.topCategories || []} layout="vertical" margin={{ left: 20 }}>
          <XAxis type="number" allowDecimals={false} tick={{ fontSize: 12 }} />
          <YAxis type="category" dataKey="label" width={110} tick={{ fontSize: 11 }} />
          <Tooltip />
          <Bar dataKey="count" fill="#6a4bd6" radius={[0, 6, 6, 0]} />
        </BarChart>
      </ChartCard>

      <ChartCard title="Top Locations" empty={(stats.topLocations || []).length === 0}>
        <BarChart data={stats.topLocations || []}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis dataKey="label" tick={{ fontSize: 11 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Bar dataKey="count" fill="#52c4c1" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ChartCard>

      <ChartCard title="Followers Distribution" empty={(stats.followersDistribution || []).length === 0}>
        <BarChart data={stats.followersDistribution || []}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis dataKey="bucket" tick={{ fontSize: 11 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Bar dataKey="count" fill="#2d1c87" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ChartCard>

      <ChartCard title="Contact Availability" empty={availability.every((a) => a.value === 0)}>
        <PieChart>
          <Pie data={availability} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
            {availability.map((entry, i) => (
              <Cell key={entry.name} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ChartCard>

      <div className="lf-chart-card">
        <h4>Summary</h4>
        <div className="lf-detail-row"><span className="lf-detail-label">Total Leads</span><span className="lf-detail-value">{stats.totalLeads}</span></div>
        <div className="lf-detail-row"><span className="lf-detail-label">Email Availability</span><span className="lf-detail-value">{stats.emailAvailability}%</span></div>
        <div className="lf-detail-row"><span className="lf-detail-label">Phone Availability</span><span className="lf-detail-value">{stats.phoneAvailability}%</span></div>
        <div className="lf-detail-row"><span className="lf-detail-label">Search Success Rate</span><span className="lf-detail-value">{stats.successRate}%</span></div>
      </div>
    </div>
  );
}

export default LeadFinderAnalytics;
